/* eslint-disable @typescript-eslint/no-explicit-any */
import {CreateModuleRequest} from "../model/request/module/CreateModuleRequest.ts";
import {BaseService} from "./BaseService.ts";

export class ModuleService {
    static create = (others: any, data: CreateModuleRequest) => {
        return BaseService.apiClient(others).post("/module/create", data);
    };
    static delete = (others: any, data: CreateModuleRequest) => {
        return BaseService.apiClient(others).post("/module/delete", data);
    };
}
